"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var operators_1 = require("rxjs/operators");
var pending_action_helper_service_1 = require("../service/pending-action-helper.service");
var pending_item_type_1 = require("../model/pending-item-type");
var PendingActionCardsComponent = /** @class */ (function () {
    function PendingActionCardsComponent(pendingActionHelperService, cdRef) {
        this.pendingActionHelperService = pendingActionHelperService;
        this.cdRef = cdRef;
        this.pendingActionItems = [];
        this.PendingItemType = pending_item_type_1.PendingItemType;
        this._destroy$ = new Subject_1.Subject();
    }
    PendingActionCardsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.pendingActionHelperService.loadPendingActionItems()
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (pendingActionItems) {
            _this.pendingActionItems = pendingActionItems;
            _this.isReady = true;
            _this.cdRef.markForCheck();
        });
    };
    PendingActionCardsComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    PendingActionCardsComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-pending-action-cards',
            template: require('./pending-action-cards.component.html'),
            styles: [require('./pending-action-cards.component.css')],
            changeDetection: core_1.ChangeDetectionStrategy.OnPush
        }),
        __metadata("design:paramtypes", [pending_action_helper_service_1.PendingActionHelperService,
            core_1.ChangeDetectorRef])
    ], PendingActionCardsComponent);
    return PendingActionCardsComponent;
}());
exports.PendingActionCardsComponent = PendingActionCardsComponent;
//# sourceMappingURL=pending-action-cards.component.js.map